<template>
  <div class="team-row">
    <div class="team-row__position">
      {{ index }}
    </div>

    <div class="team-row__logo">
      <AppSkeleton v-if="skeleton" height="50px" width="50px" />
      <img
        v-else-if="team.logo"
        class="team-row__img"
        :src="team.logo"
        :alt="team.name"
      />
      <img
        v-else
        class="team-row__img"
        src="@/assets/images/teams/no-logo.png"
        alt="no-logo"
      />
    </div>

    <div class="team-row__name">
      <AppSkeleton v-if="skeleton" :max-width="40" />
      <span v-else>{{ team.name }}</span>
    </div>

    <AppBtn
      v-if="!skeleton"
      class="team-row__btn"
      :loading="loading"
      color="third"
      @click="showTeamRoster"
    >
      Состав команды
    </AppBtn>
  </div>
</template>

<script>
import { openModal } from "./TeamView";
import service from "@/services/team";
import { requestAlert } from "@/core/common/";

export default {
  name: "TeamRow",
  props: {
    index: {
      type: Number,
      default: 1
    },
    team: {
      type: Object
    }
  },
  data: () => ({
    loading: false
  }),
  computed: {
    skeleton() {
      return !this.team;
    }
  },
  methods: {
    async showTeamRoster() {
      this.loading = true;
      try {
        const { data, success } = await service.getTeamDetails(this.team.id);
        if (success) {
          await openModal(data);
        } else {
          requestAlert();
        }
      } catch {
        requestAlert();
      }

      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
.team-row {
  display: flex;
  align-items: center;
  position: relative;
  background-color: colors(palette-2);
  height: 60px;
  color: colors(text-3);
  font-size: 20px;
  font-weight: fw(bold);
  border-radius: 4px;
  padding: 5px 20px 5px 0;

  &__position,
  &__logo {
    height: 50px;
    flex-shrink: 0;
  }

  &__logo {
    background: colors(palette-1);
    margin-right: 10px;
    width: 50px;
    height: 50px;
    color: colors(text-3);
    border-radius: 4px;
    border: 2px solid colors(palette-5);
    overflow: hidden;
  }

  &__img {
    width: 100%;
    height: 100%;
  }

  &__position {
    width: 55px;
    height: 55px;
    line-height: 55px;
    text-align: center;
  }

  &__btn {
    border-radius: 4px;
    height: 50px;
    width: 240px;
    font-size: 24px;
    font-weight: fw(bold);
    margin-left: auto;
    flex-shrink: 0;
    text-transform: uppercase;
  }

  &__name {
    flex-shrink: 1;
    flex-grow: 1;
    color: colors(text-3);
    @include text-ellipsis();
    padding-right: 10px;
  }

  @include breakpoint("md-and-down") {
    padding-right: 5px;
    &__btn {
      font-size: 16px;
      width: 170px;
    }
  }

  @include breakpoint("sm-and-down") {
    padding: 70px 10px 10px;
    flex-direction: column;
    align-items: flex-start;
    height: auto;

    &__logo {
      position: absolute;
      top: 10px;
      right: 10px;
    }

    &__position {
      position: absolute;
      top: 10px;
      left: 10px;
      background-color: colors(palette-4);
      width: 40px;
      height: 40px;
      line-height: 40px;
    }

    &__btn {
      position: static;
      height: 40px;
      width: 100%;
    }

    &__name {
      margin-bottom: 5px;
    }
  }
}
</style>
